/* 布局 */
//前台
import Layout from "@views/layout";

const propertyspectplRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "propertyspectpl/list",
        name: "PROPERTYSPECTPL",
        meta: {
            title: "资产规格模板",
            keepAlive:true
        },
        component: () => import("@views/business/propertyspectpl/index.vue"),
    },
        ],
};

export default propertyspectplRouter;
